<template>
  <div class="animated fadeI">
    <el-form
      ref="myProfileForm"
      label-position="top"
      @submit.native.prevent
      label-width="130px"
    >
      <el-card class="box-card mb-3">
        <div
          slot="header"
          class="el-card-header d-flex justify-content-between"
        >
          <span class="title-card-header">Thông tin tài sản</span>
          <div class="text-right">
            <div>
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
            </div>
          </div>
        </div>
        <div class="">
          <!-- Form search -->
          <div class="main-body-search">
            <b-collapse
              :visible.sync="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="mb-3"
            >
              <el-card>
                <el-form
                  ref="mySearchForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Tên tài sản" prop="asset_names">
                        <el-input
                          type="text"
                          v-model="
                            mData.tableRules.dataSearch.value.asset_names
                          "
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Serial number" prop="identity">
                        <el-input
                          type="text"
                          v-model.trim="
                            mData.tableRules.dataSearch.value.identity
                          "
                          @change="
                            () =>
                              (mData.tableRules.dataSearch.value.identity =
                                mData.tableRules.dataSearch.value.identity.toUpperCase())
                          "
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Trạng thái" prop="status">
                        <el-select
                          filterable
                          clearable
                          multiple
                          v-model="mData.dataDefault.listStatusFilter"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Hỏng" prop="is_broken">
                        <el-select
                          filterable
                          clearable
                          v-model="mData.tableRules.dataSearch.value.is_broken"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listStatusAsset"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      round
                      native-type="submit"
                      type="primary"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-card>
            </b-collapse>
          </div>
          <!-- Asset list -->
          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              style="width: 100%"
              max-height="450px"
              border
              :cell-class-name="fn_getCellClass"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.skip + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.name"
                label="Tên tài sản"
                min-width="150"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.asset.name"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.asset.name
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.identity"
                label="Serial number"
                min-width="105"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="asset.status"
                label="Trạng thái"
                min-width="150"
              >
                <template slot-scope="scope">
                  <span
                    class="bold"
                    :class="fn_setStatusColor(scope.row.asset.status)"
                    >{{ fn_changeDataStatus(scope.row.asset.status) }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.description"
                label="Mô tả"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.asset.description"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.asset.description
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.origin_price"
                label="Giá ban đầu"
                min-width="95"
                align="right"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_formatCurrency(scope.row.asset.origin_price)"
                  >
                    <span class="content" slot="reference">{{
                      fn_formatCurrency(scope.row.asset.origin_price)
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.is_atrophy"
                label="Tiêu hao"
                min-width="70"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.asset.is_atrophy ? 'Có' : 'Không'"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.asset.is_atrophy ? "Có" : "Không"
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.expired_atrophy"
                label="Hết hạn"
                min-width="85"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_formatDate(scope.row.asset.expired_atrophy)"
                  >
                    <span class="content" slot="reference">{{
                      fn_formatDate(scope.row.asset.expired_atrophy)
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="Hỏng" width="60" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.asset.is_broken"
                    @change="
                      fn_changeTrangThaiKhoa(
                        scope.row.asset.id,
                        scope.row.asset.is_broken
                      )
                    "
                    :disabled="
                      !mData.dataDefault.listFeature.includes('FT1602') ||
                      scope.row.asset.status != 'BROKEN_CONFIRMED'
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" align="center" min-width="630">
                <template slot-scope="scope">
                  <div class="d-flex">
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        @click="fn_handle('detail', scope.$index, scope.row)"
                        >Xem</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="fn_disabledButton('allocation_request', scope.row)"
                        @click="
                          fn_handle(
                            'allocation_request',
                            scope.$index,
                            scope.row
                          )
                        "
                        >Cấp phát</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="fn_disabledButton('allocation_confirmed', scope.row)"
                        @click="
                          fn_handle(
                            'allocation_confirmed',
                            scope.$index,
                            scope.row
                          )
                        "
                        >Xác nhận cấp phát</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="fn_disabledButton('broken_report', scope.row)"
                        @click="
                          fn_handle('broken_report', scope.$index, scope.row)
                        "
                        >Báo hỏng</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        disabled
                        @click="fn_handle('broken_confirmed', scope.$index, scope.row)"
                        >Xác nhận hỏng</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="fn_disabledButton('recall_report', scope.row)"
                        @click="
                          fn_handle('recall_report', scope.$index, scope.row)
                        "
                        >Thu hồi</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <el-link
                      type="primary"
                      disabled
                      @click="
                        fn_handle('recall_confirmed', scope.$index, scope.row)
                      "
                      >Xác nhận thu hồi</el-link
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}:
                  {{ mData.tableRules.recordSelected.length }}
                </div>
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </el-card>
    </el-form>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="formDialog"
      top="5vh"
      width="50%"
      :before-close="fn_cancel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          @submit.native.prevent
          ref="myForm"
          label-width="160px"
          label-position="top"
          v-if="mData.viewMode == 'detail'"
        >
          <b-row class="mb-1">
            <b-col md="4">
              <el-form-item label="Tên tài sản" prop="name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.name"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Serial number" prop="">
                <el-input
                  type="text"
                  v-model.trim="mData.dataForm.identity"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Trạng thái" prop="">
                <el-select
                  filterable
                  clearable
                  v-model="mData.dataForm.status"
                  :disabled="
                    mData.viewMode == 'detail' || mData.viewMode == 'create'
                  "
                >
                  <el-option
                    v-for="item in mData.dataDefault.listStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="4">
              <el-form-item label="Giá ban đầu" prop="">
                <ElementUIMoney
                  v-model="mData.dataForm.origin_price"
                  label=""
                  :disabled="mData.viewMode == 'detail'"
                  :outlined="true"
                  :clearable="true"
                  :options="options"
                />
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tiêu hao" prop="">
                <el-select
                  filterable
                  clearable
                  v-model="mData.dataForm.is_atrophy"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listAtrophy"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Thời gian hết hạn" prop="">
                <el-date-picker
                  type="date"
                  v-model="mData.dataForm.expired_atrophy"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                  :clearable="false"
                  format="dd/MM/yyyy"
                  :picker-options="pickerOptionFrom"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col>
              <el-upload
                ref="upload"
                class="upload-demo"
                action
                multiple
                :auto-upload="false"
                :accept="mData.fileUploadOption.Anh.accept"
                :on-preview="fn_uploadPreviewAnh"
                :file-list="mData.fileUploadOption.Anh.fileList"
                :disabled="mData.viewMode == 'detail'"
              >
                <el-button
                  size="small"
                  class="btn-default"
                  :disabled="mData.viewMode == 'detail'"
                >
                  Tải ảnh lên <i class="isax-arrow-up-3"></i>
                </el-button>
              </el-upload>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12">
              <el-form-item label="Mô tả" prop="description">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.description"
                  :disabled="mData.viewMode == 'detail'"
                  resize="none"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <!-- Table Xem lịch sử-->
          <div
            class="main-body-table pr-3 pl-3 mb-1"
            v-if="mData.viewMode == 'detail'"
          >
            <el-table
              :data="mData.dataDefault.listHistoryOfEmployee"
              @sort-change="fn_tableSortChange"
              border
              style="width: 100%"
              max-height="200px"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="45">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="requested_date"
                label="Thời điểm"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      fn_formatDatetime(
                        scope.row.requested_date
                          ? scope.row.requested_date
                          : scope.row.confirmed_date
                      )
                    "
                  >
                    <span class="content" slot="reference">{{
                      fn_formatDatetime(
                        scope.row.requested_date
                          ? scope.row.requested_date
                          : scope.row.confirmed_date
                      )
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="Thao tác" min-width="140">
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_changeDataStatus(scope.row.status)"
                  >
                    <span
                      class="content bold"
                      slot="reference"
                      :class="fn_setStatusColor(scope.row.status)"
                      >{{ fn_changeDataStatus(scope.row.status) }}</span
                    >
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_name"
                label="Nhân viên"
                min-width="180"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.employee_name"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.employee_name
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="description"
                label="Ghi chú"
                min-width="110"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.description"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.description
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </div>

      <!-- Form thao tác -->
      <div>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          @submit.native.prevent
          ref="formManipulate"
          label-width="160px"
          label-position="top"
          v-if="
            mData.viewMode == 'allocation_request' ||
            mData.viewMode == 'allocation_confirmed' ||
            mData.viewMode == 'recall_report' ||
            mData.viewMode == 'recall_confirmed' ||
            mData.viewMode == 'broken_report' ||
            mData.viewMode == 'broken_confirmed' ||
            mData.viewMode == 'liquidation'
          "
        >
          <b-row
            class="mb-1"
            v-if="
              mData.viewMode == 'allocation_request' ||
              mData.viewMode == 'allocation_confirmed' ||
              mData.viewMode == 'recall_report' ||
              mData.viewMode == 'recall_confirmed' ||
              mData.viewMode == 'broken_report' ||
              mData.viewMode == 'broken_confirmed'
            "
          >
            <b-col md="12">
              <el-form-item
                :label="
                  mData.viewMode == 'allocation_request' ||
                  mData.viewMode == 'allocation_confirmed'
                    ? 'Người nhận tài sản'
                    : 'Người đang sở hữu'
                "
                prop="employee_id"
              >
                <el-select
                  filterable
                  :disabled="mData.viewMode != 'allocation_request'"
                  v-model="mData.dataForm.employee_id"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listEmployee"
                    :key="item.id"
                    :label="fn_setLabelRespectively(item)"
                    :value="item.id"
                    :disabled="item.disabledOption"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12">
              <el-form-item label="Tài sản" prop="asset_id">
                <el-select
                  v-model="mData.dataForm.asset_id"
                  disabled
                  filterable
                >
                  <el-option
                    v-for="item in mData.tableRules.data"
                    :key="item.id"
                    :label="item.asset.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12">
              <el-form-item label="Ghi chú" prop="">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.descriptionEmployeeAsset"
                  :disabled="mData.viewMode == 'detail'"
                  resize="none"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <!-- Button -->
      <div class="text-center mt-2">
        <el-button
          round
          class="btn-back"
          @click="fn_cancel"
          v-if="
            mData.viewMode == 'allocation_request' ||
            mData.viewMode == 'recall_report' ||
            mData.viewMode == 'broken_report' ||
            mData.viewMode == 'liquidation'
          "
          native-type="submit"
          >Bỏ qua</el-button
        >
        <el-button
          round
          class="btn-default"
          @click="fn_submitForm(mData.viewMode)"
          v-if="
            mData.viewMode == 'allocation_request' ||
            mData.viewMode == 'recall_report' ||
            mData.viewMode == 'broken_report'
          "
          native-type="submit"
          >Thêm yêu cầu</el-button
        >
        <el-button
          round
          class="btn-back"
          @click="fn_rejectRequest"
          v-if="
            mData.viewMode == 'recall_confirmed' ||
            mData.viewMode == 'broken_confirmed' ||
            mData.viewMode == 'allocation_confirmed'
          "
          native-type="submit"
          >Từ chối</el-button
        >
        <el-button
          round
          class="btn-default"
          @click="fn_submitForm(mData.viewMode)"
          v-if="
            mData.viewMode == 'recall_confirmed' ||
            mData.viewMode == 'broken_confirmed' ||
            mData.viewMode == 'allocation_confirmed'
          "
          native-type="submit"
          >Xác nhận</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LanguageService from "@/service/LanguageService";
import DataService from "@/service/DataService";
import MethodService from "@/service/MethodService";
import ExtensionService from "@/service/ExtensionService";
import EventBus from "../../service/EventBus";
import EmployeeModel from "@/views/admin/Employees/EmployeeModel";
import AssetApi from "../../moduleApi/AssetApi";
import EmployeeAssetApi from "../../moduleApi/EmployeeAssetApi";
import EmployeeApi from "../../moduleApi/EmployeeApi";
import FileApi from "../../moduleApi/FileApi";
import ElementUIMoney from "../../component/InputComponent/ElementUiMoney";

export default {
  components: {
    ElementUIMoney,
  },
  props: {
    isBeforeEmployee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      aLang: LanguageService.lang,
      type: "",
      mData: {
        id: undefined,
        moduleName: "EmployeeManager",
        viewMode: "",
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        tableRules: MethodService.copyObject(
          EmployeeModel.tableRulesEmployeeAsset
        ),
        dataForm: MethodService.copyObject(EmployeeModel.dataEmployeeAsset),
        validForm: EmployeeModel.validEmployeeAsset,
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listEmployee: [],
          listStatus: DataService.listStatus,
          listAssetType: DataService.listAssetType,
          listAsset: [],
          listEmployeeAsset: [],
          listAllHistory: [],
          listHistoryExcept: [],
          listHistoryOfEmployee: [],
          employeeInfo: {},
          listStatusFilter: [],
          listStatusAsset: [
            {
              label: "Hỏng",
              value: true,
            },
            {
              label: "Không hỏng",
              value: false,
            },
          ],
          listAtrophy: [
            {
              label: "Có",
              value: true,
            },
            {
              label: "Không",
              value: false,
            },
          ],
        },
        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },
      pickerOptionFrom: {
        disabledDate(time) {
          return (
            time.getTime() <
            new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          );
        },
      },
      formDialog: false,
      dialogTitle: "",
      dataFilter: {},
      employee_id: "",
      routeEmployeeInfo: "Admin-EmployeeInfo-detail",
      routeEmployeeManager: "Admin-EmployeeManager-update",
    };
  },

  methods: {
    fn_disabledButton(type, row) {
      if (type === 'allocation_request') {
        if (
          !this.mData.dataDefault.listFeature.includes('FT1607') ||
          row.asset.status == 'NEW' ||
          row.asset.status == 'ALLOCATION_REQUEST' ||
          row.asset.status == 'BROKEN_REPORT' ||
          row.empAsset.status == 'NEW' ||
          row.empAsset.status == 'ALLOCATION_REQUEST' ||
          row.empAsset.status == 'BROKEN_REPORT' ||
          row.empAsset.status == 'BROKEN_CONFIRMED' ||
          row.empAsset.status == 'RECALL_CONFIRMED' ||
          row.empAsset.status == 'LIQUIDATION' ||
          row.asset.status == 'OUT_OF_STOCK' ||
          !row.existEmp
        ) {
          return true;
        }
      } else if (type === 'allocation_confirmed') {
        if (
          !this.mData.dataDefault.listFeature.includes('FT1502') ||
          row.asset.status == 'NEW' ||
          row.asset.status == 'BROKEN_REPORT' ||
          row.asset.status == 'ALLOCATION_CONFIRMED' ||
          row.empAsset.status == 'NEW' ||
          row.empAsset.status == 'BROKEN_REPORT' ||
          row.empAsset.status == 'BROKEN_CONFIRMED' ||
          row.empAsset.status == 'RECALL_REPORT' ||
          row.empAsset.status == 'RECALL_CONFIRMED' ||
          row.empAsset.status == 'ALLOCATION_CONFIRMED' ||
          row.empAsset.status == 'LIQUIDATION' ||
          row.asset.status == 'OUT_OF_STOCK' ||
          !row.existEmp
        ) {
          return true;
        }
      } else if (type === 'broken_report') {
        if (
          !this.mData.dataDefault.listFeature.includes('FT1503') ||
          row.asset.status == 'NEW' ||
          row.asset.status == 'ALLOCATION_REQUEST' ||
          row.asset.status == 'RECALL_REPORT' ||
          row.empAsset.status == 'BROKEN_REPORT' ||
          row.empAsset.status == 'BROKEN_CONFIRMED' ||
          row.empAsset.status == 'RECALL_REPORT' ||
          row.empAsset.status == 'RECALL_CONFIRMED' ||
          row.empAsset.status == 'ALLOCATION_REQUEST' ||
          row.empAsset.status == 'LIQUIDATION' ||
          row.asset.status == 'OUT_OF_STOCK' ||
          !row.existEmp
        ) {
          return true;
        }
      } else if (type === 'recall_report') {
        if (
          !this.mData.dataDefault.listFeature.includes('FT1504') ||
          row.asset.status == 'NEW' ||
          row.asset.status == 'RECALL_REPORT' ||
          row.asset.status == 'ALLOCATION_REQUEST' ||
          row.empAsset.status == 'NEW' ||
          row.empAsset.status == 'BROKEN_REPORT' ||
          row.empAsset.status == 'RECALL_REPORT' ||
          row.empAsset.status == 'RECALL_CONFIRMED' ||
          row.empAsset.status == 'LIQUIDATION' ||
          row.empAsset.status == 'ALLOCATION_REQUEST' ||
          row.asset.status == 'OUT_OF_STOCK' ||
          !row.existEmp
        ) {
          return true;
        }
      }
    },

    async fn_getListEmployee() {
      const employeeApiRes = await EmployeeApi.list({
        filters:
          "disabled=false" +
          "&status=DANG_LAM_VIEC" +
          "&company_id=" +
          this.mData.currentCompany.id,
        limit: 5000,
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        employeeApiRes.result.forEach(emp => emp.disabledOption = emp.id == this.employee_id ? true : false);
        this.mData.dataDefault.listEmployee = employeeApiRes.result;
      }
    },

    fn_setLabelRespectively(item) {
      return `${item.employee_no ? item.employee_no : ""} - ${
        item.administrative_info.name.full_name
          ? item.administrative_info.name.full_name
          : ""
      }`;
    },

    fn_setRoute() {
      if (this.mData.tableRules.showUrl) {
        if (this.$router.currentRoute.name == "Admin-EmployeeInfo-detail") {
          this.$router
            .replace({
              name: this.routeEmployeeInfo,
              query: {
                ...this.dataFilter,
              },
            })
            .catch((err) => {});
        } else {
          if (!this.isBeforeEmployee) {
            if (this.dataFilter.asset_names) delete this.dataFilter.asset_names;
            if (this.dataFilter.identity) delete this.dataFilter.identity;
            if (this.dataFilter.status) delete this.dataFilter.status;
            if (this.dataFilter.is_broken) delete this.dataFilter.is_broken;
          }
          this.$router
            .replace({
              name: this.routeEmployeeManager,
              query: {
                ...this.dataFilter,
              },
            })
            .catch((err) => {});
        }
      }
    },

    async fn_initTable() {
      this.dataFilter = {
        ...this.dataFilter,
        tab: "TaiSan",
      };
      if (this.mData.tableRules.allowPaging) {
        this.dataFilter.limit = this.mData.tableRules.limit;
        this.dataFilter.skip = this.mData.tableRules.skip;
      }
      this.dataFilter.employee_id = this.$router.currentRoute.params.id;
      this.fn_setRoute();
      const res = await AssetApi.GetListAsset(this.dataFilter);
      res.result.lstAssets.forEach((el) => {
        if (el.empAsset && el.empAsset.hasOwnProperty("employee_id") == true) {
          if (el.empAsset.employee_id == this.employee_id) {
            el.existEmp = true;
          } else {
            el.existEmp = false;
          }
        } else {
          el.existEmp = false;
        }
      });
      this.mData.tableRules.total = res.result.total;
      if (res.result && res.result.lstAssets.length > 0) {
        this.mData.tableRules.data = res.result.lstAssets;
        this.mData.tableRules.page =
          this.mData.tableRules.skip / this.mData.tableRules.limit + 1;
      } else {
        this.mData.tableRules.data = [];
      }
      if (
        this.mData.tableRules.skip == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.skip =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        await this.fn_initTable();
      }
    },

    fn_setStatusColor(status) {
      return status == "NEW"
        ? "new-asset"
        : status == "BROKEN_REPORT"
        ? "broken-report-asset"
        : status == "BROKEN_CONFIRMED"
        ? "broken-confirmed-asset"
        : status == "RECALL_REPORT"
        ? "recall-report-asset"
        : status == "RECALL_CONFIRMED"
        ? "recall-confirmed-asset"
        : status == "ALLOCATION_REQUEST"
        ? "allocation-request-asset"
        : status == "ALLOCATION_CONFIRMED"
        ? "allocation-confirmed-asset"
        : status == "LIQUIDATION"
        ? "liquidation-asset"
        : "";
    },

    fn_setDialogTitle() {
      return (this.dialogTitle =
        this.mData.viewMode == "create"
          ? "Thêm mới tài sản"
          : this.mData.viewMode == "update"
          ? "Cập nhật tài sản"
          : this.mData.viewMode == "detail"
          ? "Chi tiết tài sản"
          : this.mData.viewMode == "allocation_request"
          ? "Thêm mới yêu cầu cấp phát tài sản"
          : this.mData.viewMode == "allocation_confirmed"
          ? "Xác nhận cấp phát tài sản"
          : this.mData.viewMode == "recall_report"
          ? "Thêm mới yêu cầu thu hồi tài sản"
          : this.mData.viewMode == "recall_confirmed"
          ? "Xác nhận thu hồi tài sản"
          : this.mData.viewMode == "broken_report"
          ? "Thêm mới báo hỏng tài sản"
          : this.mData.viewMode == "broken_confirmed"
          ? "Xác nhận báo hỏng tài sản"
          : "Thanh lý tài sản");
    },

    async fn_changeTrangThaiKhoa(id, trangThai) {
      let data = {
        id: id,
        is_broken: trangThai,
        conpany_id: this.mData.currentCompany.id,
      };
      try {
        await AssetApi.update(data);
        window.toastr.success("Cập nhật thành công");
      } catch (error) {
        console.log(error);
      }
    },

    async fn_getHistoryAsset(id) {
      this.mData.dataDefault.listAllHistory = [];
      this.mData.dataDefault.listHistoryExcept = [];
      this.mData.dataDefault.listHistoryOfEmployee = [];
      const employeeAssetApi = await EmployeeAssetApi.list({
        filters: `asset_id=${id}`,
        limit: 500,
      });
      if (employeeAssetApi.result) {
        employeeAssetApi.result.forEach((el1) => {
          this.mData.dataDefault.listEmployee.forEach((el2) => {
            if (el1.employee_id == el2.id) {
              el1.employee_name = el2.administrative_info.name.full_name;
            }
          });
        });
        this.mData.dataDefault.listAllHistory = employeeAssetApi.result;
        this.mData.dataDefault.listHistoryExcept =
          employeeAssetApi.result.filter(
            (el) =>
              el.status != "ALLOCATION_REJECTED" &&
              el.status != "RECALL_REJECTED" &&
              el.status != "BROKEN_REJECTED"
          );
        this.mData.dataDefault.listHistoryOfEmployee =
          employeeAssetApi.result.filter(
            (el) =>
              el.employee_id == this.$router.currentRoute.params.id ||
              !el.employee_id
          );
      }
    },

    async fn_getAssetById(id) {
      let res = await AssetApi.findById(id);
      if (res.result) {
        this.mData.dataForm = res.result;
      }
      if (
        this.mData.dataForm.file_ids &&
        this.mData.dataForm.file_ids.length > 0
      ) {
        const listFile = await FileApi.list(
          {
            limit: this.mData.dataForm.file_ids.length,
            filters: "id:in:" + this.mData.dataForm.file_ids.join(","),
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.Anh.fileList = data;
      } else {
        this.mData.dataForm.file_ids = [];
      }
    },

    closeDialogImage() {
      this.mData.fileUploadOption.Anh.dialogImageUrl = "";
      this.mData.fileUploadOption.Anh.dialogVisible = false;
    },

    fn_uploadPreviewAnh(file) {
      this.mData.fileUploadOption.Anh.dialogImageUrl =
        ExtensionService.urlImg + file.id;
      this.mData.fileUploadOption.Anh.dialogVisible = true;
    },

    async fn_handle(type, scope, row) {
      this.formDialog = true;
      let data = this.mData.dataForm;
      this.mData.id = row.asset.id;
      if (type == "detail") {
        this.fn_getAssetById(row.asset.id);
      } else {
        data.description = "";
      }
      if (
        type == "detail" ||
        type == "allocation_confirmed" ||
        type == "recall_confirmed" ||
        type == "broken_confirmed"
      ) {
        this.fn_getHistoryAsset(row.asset.id);
      }
      if (type != "detail" && type != "allocation_request") {
        data.employee_id = this.employee_id;
      }
      data.asset_id = row.asset.id;
      this.mData.viewMode = type;
      this.fn_setDialogTitle();
    },

    fn_submitForm(type) {
      this.$refs["formManipulate"].validate(async (valid) => {
        if (!valid) {
          MethodService.stopLadda();
          return false;
        }

        let data = this.mData.dataForm;
        let dataUpdateAsset = {};
        try {
          if (
            type == "recall_report" ||
            type == "broken_report" ||
            type == "allocation_request"
          ) {
            data.requested_date = new Date();
            data.requested_user_id = this.$router.currentRoute.params.id;
          } else {
            data.confirmed_date = new Date();
            data.confirmed_user_id = this.$router.currentRoute.params.id;
          }

          if (type == "allocation_request") {
            data.type = "ALLOCATION";
            data.status = "ALLOCATION_REQUEST";
          } else if (type == "allocation_confirmed") {
            data.type = "ALLOCATION";
            data.status = "ALLOCATION_CONFIRMED";
          } else if (type == "recall_report") {
            data.type = "RECALL";
            data.status = "RECALL_REPORT";
          } else if (type == "recall_confirmed") {
            data.type = "RECALL";
            data.status = "RECALL_CONFIRMED";
          } else if (type == "broken_report") {
            data.type = "BROKEN";
            data.status = "BROKEN_REPORT";
          } else if (type == "broken_confirmed") {
            data.type = "BROKEN";
            data.status = "BROKEN_CONFIRMED";
          }
          dataUpdateAsset = {
            id: data.asset_id,
            status: data.status,
            status_order: this.fn_setStatusOrder(data.status),
          };
          data.description = data.descriptionEmployeeAsset
            ? data.descriptionEmployeeAsset
            : "";

          const listHistory = this.mData.dataDefault.listAllHistory;
          const stt = this.fn_getAssetStatusLogRespectively(listHistory)
            ? this.fn_getAssetStatusLogRespectively(listHistory)
            : null;
          if (
            stt &&
            listHistory[listHistory.length - 1].requested_user_id == stt.employee_id &&
            stt.status == "ALLOCATION_CONFIRMED" && type == 'allocation_confirmed' ||
            stt &&
            listHistory[listHistory.length - 1].requested_user_id == stt.employee_id &&
            stt.status == "RECALL_REPORT" && type == 'allocation_confirmed'
          ) {
            // Case 1: A Báo cấp phát B -> B xác nhận cấp phát
            // Case 2: A Báo thu hồi -> A báo cấp phát B -> B xác nhận
            const confirmedAssetApiRes = await AssetApi.ConfirmedAsset({
              employee_asset_id: listHistory[listHistory.length - 1].id,
            });
            if (confirmedAssetApiRes.code == 0) {
              window.toastr.success(`${this.fn_showTypeNoti(type)} thành công`);
            }
          } else if (
            stt &&
            listHistory[listHistory.length - 2].requested_user_id == stt.employee_id &&
            stt.status == "RECALL_REPORT" && type == 'allocation_confirmed'
          ) {
            // Case 3: A báo cấp phát B -> A báo thu hồi -> B xác nhận
            const confirmedAssetApiRes = await AssetApi.ConfirmedAsset({
              employee_asset_id: listHistory[listHistory.length - 2].id,
            });
            if (confirmedAssetApiRes.code == 0) {
              window.toastr.success(`${this.fn_showTypeNoti(type)} thành công`);
            }
          } else {
            await EmployeeAssetApi.create(data);
            await AssetApi.update(dataUpdateAsset);
            window.toastr.success(`${this.fn_showTypeNoti(type)} thành công`);
          }
          await this.fn_resetFormManipulate();
          await this.fn_initTable();
          this.mData.viewMode = "create";
        } catch (error) {
          console.log("error", error);
          window.toastr.error("Tài sản không hợp lệ");
        }
      });
    },

    fn_showTypeNoti(type) {
      return type == "allocation_confirmed"
        ? "Xác nhận cấp phát"
        : type == "allocation_request"
        ? "Báo cấp phát"
        : type == "broken_report"
        ? "Báo hỏng"
        : type == "broken_confirmed"
        ? "Xác nhận hỏng"
        : type == "recall_report"
        ? "Báo thu hồi"
        : type == "recall_confirmed"
        ? "Xác nhận thu hồi"
        : "Thao tác";
    },

    fn_changeDataStatus(status) {
      return status == "NEW"
        ? "Mới"
        : status == "BROKEN_REPORT"
        ? "Báo hỏng"
        : status == "BROKEN_CONFIRMED"
        ? "Xác nhận hỏng"
        : status == "RECALL_REPORT"
        ? "Báo thu hồi"
        : status == "RECALL_CONFIRMED"
        ? "Xác nhận thu hồi"
        : status == "ALLOCATION_REQUEST"
        ? "Báo cấp phát"
        : status == "ALLOCATION_CONFIRMED"
        ? "Xác nhận cấp phát"
        : status == "LIQUIDATION"
        ? "Thanh lý"
        : status == "ALLOCATION_REJECTED"
        ? "Từ chối cấp phát"
        : status == "RECALL_REJECTED"
        ? "Từ chối thu hồi"
        : status == "BROKEN_REJECTED"
        ? "Từ chối báo hỏng"
        : status == "OUT_OF_STOCK"
        ? "Hết"
        : "";
    },

    fn_cancel() {
      if (this.mData.viewMode == "detail") {
        this.fn_resetForm();
        return;
      }
      this.fn_resetFormManipulate();
    },

    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.formDialog = false;
    },

    fn_resetFormManipulate() {
      this.mData.dataForm = MethodService.copyObject(EmployeeModel.dataEmployeeAsset);
      this.$refs["formManipulate"].resetFields();
      this.formDialog = false;
    },

    fn_formatDatetime(requested_date) {
      return MethodService.formatDate(requested_date, "datetime");
    },

    fn_fillEmployeeId(status) {
      if (status == "NEW" || status == "ALLOCATION_REJECTED") {
        return null;
      }
      return this.mData.dataForm.employee_id;
    },

    async fn_rejectRequest() {
      try {
        let data = this.mData.dataForm;
        let obj = this.fn_setStatusAfterReject();
        const dataEmployeeAsset = {
          asset_id: this.mData.id,
          company_id: this.mData.currentCompany.id,
          employee_id: this.fn_fillEmployeeId(
            this.fn_setStatusEmployeeAssetReject()
          ),
          type: obj.type,
          status: this.fn_setStatusEmployeeAssetReject(),
          confirmed_date: new Date(),
          confirmed_user_id: this.$router.currentRoute.params.id,
          description: data.descriptionEmployeeAsset
            ? data.descriptionEmployeeAsset.trim()
            : null,
        };

        await EmployeeAssetApi.create(dataEmployeeAsset);
        await this.fn_getHistoryAsset(this.mData.id);
        obj = await this.fn_setStatusAfterReject();
        const dataUpdateAsset = {
          id: data.asset_id,
          status: obj.status,
          status_order: this.fn_setStatusOrder(obj.status),
        };
        await AssetApi.update(dataUpdateAsset);
        this.fn_resetFormManipulate();
        window.toastr.success("Từ chối thành công");
        await this.fn_initTable();
      } catch (error) {
        console.log("error", error);
      }
    },
    // Set status of Aset
    fn_setStatusAfterReject() {
      let obj = {};
      if (this.mData.dataDefault.listAllHistory.length < 3) {
        return (obj = { type: "NEW", status: "NEW" });
      }
      let lastStatus = null;
      let el = this.mData.dataDefault.listAllHistory;
      lastStatus = this.fn_getAssetStatusLog(el);
      obj = {
        type: lastStatus != null ? lastStatus.type : "NEW",
        status: lastStatus != null ? lastStatus.status : "NEW",
      };
      return obj;
    },

    fn_setStatusEmployeeAssetReject() {
      const lastStatus =
        this.mData.dataDefault.listHistoryExcept[
          this.mData.dataDefault.listHistoryExcept.length - 1
        ].status;
      let rejectStatus = "";
      if (lastStatus == "BROKEN_REPORT") {
        rejectStatus = "BROKEN_REJECTED";
      } else if (lastStatus == "RECALL_REPORT") {
        rejectStatus = "RECALL_REJECTED";
      } else if (lastStatus == "ALLOCATION_REQUEST") {
        rejectStatus = "ALLOCATION_REJECTED";
      } else {
        rejectStatus =
          this.mData.dataDefault.listHistoryExcept[
            this.mData.dataDefault.listHistoryExcept.length - 1
          ].status;
      }
      return rejectStatus;
    },

    fn_getAssetStatusLog(histories) {
      if (!histories || histories.length == 0) {
        return null;
      } else {
        let el = histories;
        for (let i = el.length - 1; i >= 0; i--) {
          if (
            el[i].status == "ALLOCATION_REJECTED" ||
            el[i].status == "RECALL_REJECTED" ||
            el[i].status == "BROKEN_REJECTED"
          ) {
            const newEl = el.slice(0, i - 1);
            return this.fn_getAssetStatusLog(newEl);
          } else {
            return el[i];
          }
        }
      }
    },

    fn_getAssetStatusLogRespectively(histories) {
      if (!histories || histories.length == 0) {
        return null;
      } else {
        let el = histories;
        for (let i = el.length - 1; i >= 0; i--) {
          if (
            el[i].status == "ALLOCATION_CONFIRMED" ||
            el[i].status == "RECALL_REPORT"
          ) {
            return el[i];
          } else {
            const newEl = el.slice(0, i);
            return this.fn_getAssetStatusLogRespectively(newEl);
          }
        }
      }
    },

    fn_setStatusOrder(statusType) {
      return statusType == "NEW"
        ? 0
        : statusType == "BROKEN_REPORT"
        ? 1
        : statusType == "BROKEN_CONFIRMED"
        ? 2
        : statusType == "RECALL_REPORT"
        ? 3
        : statusType == "RECALL_CONFIRMED"
        ? 4
        : statusType == "ALLOCATION_REQUEST"
        ? 5
        : statusType == "ALLOCATION_CONFIRMED"
        ? 6
        : statusType == "LIQUIDATION"
        ? 7
        : "";
    },

    fn_getCellClass({ row, column, columnIndex }) {
      return columnIndex == 6 ? "last-cell" : "";
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },

    //search
    fn_tableSearch() {
      this.isBeforeEmployee = true;
      let dataSearch = this.mData.tableRules.dataSearch;
      if (dataSearch.value.emp_names) {
        this.dataFilter.emp_names = MethodService.changeAlias(
          dataSearch.value.emp_names
        ).split(" ");
      } else {
        delete this.dataFilter.emp_names;
      }
      if (dataSearch.value.asset_names) {
        this.dataFilter.asset_names = MethodService.changeAlias(
          dataSearch.value.asset_names
        ).split(" ");
      } else {
        delete this.dataFilter.asset_names;
      }
      if (dataSearch.value.identity) {
        this.dataFilter.identity = dataSearch.value.identity.trim();
      } else {
        delete this.dataFilter.identity;
      }
      if (this.mData.dataDefault.listStatusFilter.length > 0) {
        // dataSearch.value.status =
        //   this.mData.dataDefault.listStatusFilter.join(",");
        this.dataFilter.status = this.mData.dataDefault.listStatusFilter;
      } else {
        delete this.dataFilter.status;
      }
      if (dataSearch.value.is_broken !== "") {
        this.dataFilter.is_broken = dataSearch.value.is_broken;
      } else {
        delete this.dataFilter.is_broken;
      }
      this.$refs["mySearchForm"].validate(async (valid) => {
        if (!valid) {
          MethodService.stopLadda();
          return false;
        }
        // this.mData.tableRules.filters = MethodService.filterTable(
        //   JSON.stringify(dataSearch)
        // );
        this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
          "company_id=system",
          "company_id:is_null:true"
        );
        this.mData.tableRules.skip = 0;
        this.fn_initTable();
      });
    },

    fn_formatCurrency(value) {
      return MethodService.formatCurrency(value);
    },

    fn_formatDate(value) {
      return MethodService.formatDate(value, "date");
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.fn_setRoute();
    },

    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },

    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.skip =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.skip =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }

      if (this.$route.query.asset_names && this.isBeforeEmployee) {
        this.mData.tableRules.dataSearch.value.asset_names = Array.isArray(
          this.$route.query.asset_names
        )
          ? this.$route.query.asset_names.join(" ")
          : this.$route.query.asset_names;
        this.dataFilter.asset_names = Array.isArray(
          this.$route.query.asset_names
        )
          ? this.$route.query.asset_names
          : [this.$route.query.asset_names];
      }
      if (this.$route.query.identity && this.isBeforeEmployee) {
        this.mData.tableRules.dataSearch.value.identity =
          this.$route.query.identity;
        this.dataFilter.identity = this.$route.query.identity;
      }
      if (this.$route.query.is_broken == "true" && this.isBeforeEmployee) {
        this.mData.tableRules.dataSearch.value.is_broken = true;
        this.dataFilter.is_broken = this.$route.query.is_broken;
      }
      if (this.$route.query.is_broken == "false" && this.isBeforeEmployee) {
        this.mData.tableRules.dataSearch.value.is_broken = false;
        this.dataFilter.is_broken = this.$route.query.is_broken;
      }
      if (
        this.mData.tableRules.dataSearch.value.status &&
        this.isBeforeEmployee
      ) {
        this.mData.dataDefault.listStatusFilter =
          this.mData.tableRules.dataSearch.value.status.split(",");
        this.dataFilter.status = this.$route.query.status;
      }
    },

    fn_reRenderDefault() {
      this.mData.tableRules.page = 1;
      this.mData.tableRules.skip = 0;
      this.employee_id = this.$router.currentRoute.params.id;
      this.fn_getListEmployee();
      this.fn_initTable();
    },
  },

  //run after render view
  async created() {
    this.employee_id = this.$router.currentRoute.params.id;
    await this.fn_hashUrl();
    await this.fn_getListEmployee();
    await this.fn_initTable();
    EventBus.$off("click_TaiSan");
    EventBus.$off("rowClick_TaiSan");
    EventBus.$off("tab_TaiSan");

    EventBus.$on("click_TaiSan", () => {
      this.fn_reRenderDefault();
    });
    EventBus.$on("rowClick_TaiSan", () => {
      this.fn_reRenderDefault();
    });
    EventBus.$on("tab_TaiSan", () => {
      this.fn_reRenderDefault();
    });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-select {
  .el-select__tags {
    height: 37px;
    overflow: auto;
  }
}

::v-deep .el-card__header {
  padding: 20px 20px 5px 20px;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 12px;
}

::v-deep .el-link.el-link--primary {
  color: #444242 !important;
}

::v-deep .el-table__row {
  background-color: #fff !important;
}

::v-deep .el-link.el-link--primary.is-disabled {
  color: #bebebe !important;
}

::v-deep .el-table__fixed {
  bottom: 10px !important;
  &:before {
    background-color: #fff;
  }
}

.line {
  width: 0.1px;
  height: 20px;
  background-color: var(--recall-confirmed-asset);
  margin-left: 8px;
}

::v-deep .last-cell {
  .cell {
    display: flex;
  }
}

::v-deep .el-link--inner {
  font-size: 12px;
}

.new-asset {
  color: var(--new-asset);
}

.broken-report-asset {
  color: var(--broken-report-asset);
}

.broken-confirmed-asset {
  color: var(--broken-confirmed-asset);
}

.recall-report-asset {
  color: var(--recall-report-asset);
}

.recall-confirmed-asset {
  color: var(--recall-confirmed-asset);
}

.allocation-request-asset {
  color: var(--allocation-request-asset);
}

.allocation-confirmed-asset {
  color: var(--allocation-confirmed-asset);
}

.liquidation-asset {
  color: var(--liquidation-asset);
}

p {
  margin-bottom: 0;
}
.title-card-header {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}
::v-deep .el-collapse {
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
::v-deep .el-collapse-item__header {
  background-color: #fff !important;
  border-radius: 4px;
}
.justify-content {
  justify-content: center;
  align-items: center;
}
::v-deep .el-link--primary {
  margin-left: 10px;
}
::v-deep .el-link--inner::after {
  color: var(--orange) !important;
}
.img__icon-plus {
  width: 39px;
  height: 39px;
  background-color: #fff;
  box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
  border-radius: 50%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mouse__hover:hover {
  cursor: pointer;
}
</style>
